import OutlineButton from "./common/outline-btn";

export default function Experience({ toggleModal }) {
  return (
    <section className="relative block w-full overflow-hidden lg:py-[70px] py-[40px]">
      <div className="blueAnimation" />
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:grid gap-8 grid-cols-2 w-full relative overflow-hidden items-center">
          <div className="lg:mb-0 mb-6">
            <div data-aos="fade-right" data-aos-duration="2200">
              <div>
                <img
                  src="https://glocify.com/images/live-hero-img-mob.png"
                  alt="live-hero-img"
                  className="w-full"
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="relative"
              data-aos="fade-left"
              data-aos-duration="2600"
            >
              <div className="lg:p-14 p-0">
                <h2 className="lg:text-[50px] text-[35px] font-bold lg:leading-[76px] tracking-tight mb-5">
                  <span className="bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent">
                    Go Live
                  </span>{" "}
                  Fast
                </h2>
                <p className="text-base font-normal leading-6 text-black mb-4">
                  Our decade of experience allow us to understand customer's
                  requirement better and move fast. We build apps quickly. The
                  sooner you initiate your project, the sooner you can launch,
                  gather essential market feedback, and strategically guide your
                  growth.
                </p>

                <p className="text-base font-normal leading-6 text-black mb-6">
                  We can assemble a highly skilled app development group within
                  three days, ensuring that your project progresses without
                  delay.
                </p>
                {/* <button
                  className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden text-base uppercase font-medium text-[#7C46EF] transition-all duration-150 ease-in-out rounded-full hover:pl-10 hover:pr-6 border border-solid border-[#7C46EF] group xl:w-auto lg:w-auto md:w-auto w-full"
                  onClick={toggleModal}
                >
                  <span className="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                    <svg
                      className="w-4 h-4 text-[#7C46EF]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </span>
                  <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                    <svg
                      className="w-4 h-4 text-[#7C46EF]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </span>
                  <span className="relative w-full text-left transition-colors duration-200 ease-in-out group-hover:text-[#7C46EF]">
                    Talk to an Expert
                  </span>
                </button> */}
                <OutlineButton
                  toggleModal={toggleModal}
                  title={"Talk to an Expert"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
